/* eslint-disable*/
import {
  Grid,
  TextField,
  withStyles,
  MenuItem,
  Button,
  Divider,
  Typography,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import styles from "../style";
import { DeleteOutline as Delete } from "@material-ui/icons";
import { CircularProgress } from "../../../utility/ui";
import { useAlert, useFetch } from "../../../utility/customHooks";
import OrchidsLogo from "../../../assets/orchidsLogo.png";
import urls from "../../../urls";
import Map from "../gMap";
import moment from "moment";

const FormEnquiry = ({
  classes,
  branchId,
  branchList,
  academicYearList,
  selectedYear,
  countryCodeArray,
  newContact,
  history,
  studentdata,
  submitDetails,
  countryCodePrimary,
  sourceList,
  formType,
}) => {
  const [loading, setLoading] = useState(false);
  const [academicYear, setAcademicYear] = useState("");
  const [branchLoc, setBranchLoc] = useState({
    lat: 13.0342708,
    lng: 77.56816509999999,
  });
  const [leadName, setLeadName] = useState("");
  const [leadNumber, setLeadNumber] = useState("");
  const [alternateMobile, setAlternateMobile] = useState("");
  const [email, setEmail] = useState("");
  // eslint-disable-next-line no-unused-vars
  const [address, setAddress] = useState("");
  const [existChild, setExistChild] = useState([]);
  const [siblingChild, setsiblingChild] = useState([]);
  const [childRequired, setChildRequired] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [lat, setLat] = useState("");
  const [lng, setLng] = useState("");
  const [googleAddress, setGoogleAddress] = useState("");
  const [countryCode, setCountryCode] = useState("+91");
  const [maxRange, setMaxRange] = useState(0);
  const [validNo, setValidNo] = useState("");
  const [mapDataObj, setMapDataObj] = useState({});
  const [selectedSource, setSelectedSource] = useState("");

  const alert = useAlert();

  let circularProgress = null;
  if (loading) {
    circularProgress = <CircularProgress open />;
  }

  useEffect(() => {
    if (branchList && branchList.length) {
      let array = branchList.filter((item) => item.id === parseInt(branchId));
      if (
        array.length &&
        array[0].branch_latitude &&
        array[0].branch_longitude
      ) {
        setBranchLoc({
          lat: array[0].branch_latitude,
          lng: array[0].branch_longitude,
        });
      }
    }
  }, [branchList, branchId]);

  const { data: grade, doFetch: fetchGrade } = useFetch([]);
  useEffect(() => {
    if (branchId) {
      fetchGrade({
        url: `${urls.branchWiseGrade}?branch=${branchId}`,
        method: "GET",
        headers: {
          "Content-Type": "application/json",
           "X-DTS-SCHEMA": urls.xdtsHost,
        },
      });
    }
  }, [branchId, fetchGrade]);

  const alternateMobileHandler = (value) => {
    setAlternateMobile(value);
    setValidNo("");
    if (value.length === 10) {
      fetch(
        `${
          urls.CheckAlternateNo
        }?contact_no=${value}&academic_year=${selectedYear}&lead_id=${
          (studentdata && studentdata.id && studentdata.id) || null
        }`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
             "X-DTS-SCHEMA": urls.xdtsHost,
          },
        }
      )
        .then((response) => response.json())
        .then((data) => {
          setValidNo(data);
        })
        .catch(() => {
          alert.error("Failed To Complete Action");
        });
    }
  };

  useEffect(() => {
    if (studentdata.id && branchId) {
      // setShowModal(!!studentdata.google_latitude);
      // setIsGoogle(!!studentdata.google_latitude);
      setLat(studentdata.google_latitude || "");
      setLng(studentdata.google_longitude || "");
      setGoogleAddress(studentdata.google_address || "");
      setExistChild(studentdata.exist_child || []);
      setsiblingChild(studentdata.new_child || []);
      setSelectedSource(
        studentdata &&
          studentdata.contact_source &&
          studentdata.contact_source.id
      );
      setAcademicYear(
        studentdata && studentdata.academic_year
          ? studentdata.academic_year
          : ""
      );
      setBranchLoc({
        lat:
          studentdata &&
          studentdata.branch &&
          studentdata.branch.branch_latitude
            ? studentdata.branch.branch_latitude
            : lat,
        lng:
          studentdata &&
          studentdata.branch &&
          studentdata.branch.branch_longitude
            ? studentdata.branch.branch_longitude
            : lng,
      });
      setLeadName(
        studentdata && studentdata.lead_name ? studentdata.lead_name : ""
      );
      setCountryCode(
        studentdata && studentdata.country_code_alternate
          ? `+${studentdata.country_code_alternate}`
          : ""
      );
      setAlternateMobile((studentdata && studentdata.lead_alternateNo) || "");
      setLeadNumber(
        studentdata && studentdata.lead_contact_no
          ? studentdata.lead_contact_no
          : newContact
      );
      setEmail(
        studentdata && studentdata.lead_email_id
          ? studentdata.lead_email_id
          : ""
      );
      setAddress(
        studentdata && studentdata.lead_address ? studentdata.lead_address : ""
      );
      alternateMobileHandler(
        studentdata && studentdata.lead_alternateNo
          ? studentdata.lead_alternateNo
          : ""
      );
    }
  }, [studentdata, newContact, branchId]);

  useEffect(() => {
    if (selectedYear && !studentdata.lead_contact_no) {
      setAcademicYear(selectedYear);
    }
  }, [selectedYear, studentdata]);

  useEffect(() => {
    if (newContact) {
      setLeadNumber(newContact);
    }
  }, [newContact]);
  useEffect(() => {
    if (countryCode === "+91") {
      setMaxRange(10);
    } else if (countryCode === "+7") {
      setMaxRange(10);
    } else if (countryCode === "+1") {
      setMaxRange(10);
    } else if (countryCode === "+968") {
      setMaxRange(8);
    } else if (countryCode === "+65") {
      setMaxRange(8);
    } else if (countryCode === "+971") {
      setMaxRange(13);
    } else if (countryCode === "+44") {
      setMaxRange(11);
    } else if (countryCode === "+84") {
      setMaxRange(11);
    } else if (countryCode === "+49") {
      setMaxRange(11);
    } else if (countryCode === "+60") {
      setMaxRange(10);
    }
  }, [countryCode]);
  const refreshContact = () => {
    setAlternateMobile("");
  };

  const setMapData = (mapData) => {
    if (mapData) {
      setMapDataObj(mapData);
      setLat(mapData.mapPosition && mapData.mapPosition.lat);
      setLng(mapData.mapPosition && mapData.mapPosition.lng);
      setGoogleAddress(mapData.address);
    }
  };

  const showMap = () => {
    // setIsGoogle(true);
    setShowModal(!showModal);
  };
  const submitForm = () => {
    let validate = true;
    siblingChild.forEach((data) => {
      if (!data.child_name) {
        validate = false;
      }
    });
    if (!validate) {
      alert.warning("Please Fill All Child Fields");
      return;
    }
    // if (!isGoogle) {
    //   alert.warning('Please Select a location');
    //   return;
    // }
    if (mapDataObj && +mapDataObj.lat === 13.0342708) {
      alert.warning("Please Select a location");
      return;
    }
    if (!selectedYear.length || !leadNumber) {
      alert.warning("Please Fill All Fields");
      return;
    }
    if (!selectedSource) {
      alert.warning("Please Select Source");
      return;
    }
    if (!leadName.trim()) {
      alert.warning("Please Add Lead Name");
      return;
    }
    if (!email.trim()) {
      alert.warning("Please Add Email");
      return;
    }
    if (!address.trim()) {
      alert.warning("Please Add Address");
      return;
    }
    if (!childRequired && !studentdata) {
      alert.warning("Please Add Child Fields");
      return;
    }
    if (!googleAddress) {
      alert.warning("Please Add map address");
      return;
    }
    if (!/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
      alert.warning("Please Enter Proper Email Address");
      return;
    }
    if (countryCode === "+91") {
      if (alternateMobile && alternateMobile.length !== 10) {
        alert.warning("Phone No. should be of 10 digits");
        return;
      }
    } else if (countryCode === "+1") {
      if (alternateMobile && alternateMobile.length !== 10) {
        alert.warning("Phone No. should be of 10 digits");
        return;
      }
    } else if (countryCode === "+7") {
      if (alternateMobile && alternateMobile.length !== 10) {
        alert.warning("Phone No. should be of 10 digits");
        return;
      }
    } else if (countryCode === "+968") {
      if (alternateMobile && alternateMobile.length !== 8) {
        alert.warning("Phone No. should be of 8 digits");
        return;
      }
    } else if (countryCode === "+65") {
      if (alternateMobile && alternateMobile.length !== 8) {
        alert.warning("Phone No. should be of 8 digits");
        return;
      }
    } else if (countryCode === "+971") {
      if (alternateMobile && alternateMobile.length !== 13) {
        alert.warning("Phone No. should be of 13 digits");
        return;
      }
    } else if (countryCode === "+44") {
      if (alternateMobile && alternateMobile.length !== 11) {
        alert.warning("Phone No. should be of 11 digits");
        return;
      }
    } else if (countryCode === "+84") {
      if (alternateMobile && alternateMobile.length !== 11) {
        alert.warning("Phone No. should be of 11 digits");
        return;
      }
    } else if (countryCode === "+49") {
      if (alternateMobile && alternateMobile.length !== 11) {
        alert.warning("Phone No. should be of 11 digits");
        return;
      }
    } else if (countryCode === "+60") {
      if (alternateMobile && alternateMobile.length !== 10) {
        alert.warning("Phone No. should be of 10 digits");
        return;
      }
    }
    const code = countryCode.slice(1);
    window.scrollTo(0, 0);
    submitDetails({
      academic_year: academicYear,
      branch: branchId,
      contact_source: { id: selectedSource },
      lead_name: leadName,
      lead_contact_no: leadNumber,
      lead_alternateNo: alternateMobile,
      country_code_primary: countryCodePrimary,
      country_code_alternate: code,
      lead_email_id: email,
      lead_address: address,
      google_latitude:
        (mapDataObj && mapDataObj.mapPosition && mapDataObj.mapPosition.lat) ||
        lat,
      google_longitude:
        (mapDataObj && mapDataObj.mapPosition && mapDataObj.mapPosition.lng) ||
        lng,
      google_address: googleAddress,
      exist_child: existChild.map((child) => ({
        child_name: child.child_name,
        child_gender: child.child_gender,
        child_birthday: child.Date_of_birth,
      })),
      new_child: [...siblingChild],
    });
  };

  const leadNameHandler = (e) => {
    setLeadName(e.target.value);
  };
  const AddressDetailsHandler = (e) => {
    setAddress(e.target.value);
  };

  const leadEmailHandler = (e) => {
    setEmail(e.target.value);
  };

  const editNewChild = (e, index, key) => {
    const {
      target: { value },
    } = e;
    setExistChild((previousData) => {
      const latest = [...previousData];
      latest[index][key] = value || "";
      return latest;
    });
  };

  const siblingNewChild = (e, index, key) => {
    const {
      target: { value },
    } = e;
    setsiblingChild((previousData) => {
      const latest = [...previousData];
      if (key === "child_class") {
        const selectedGrade = grade.filter((item) => +item.id === +value)[0];
        latest[index][key] = selectedGrade || "";
      } else {
        latest[index][key] = value || "";
      }
      return latest;
    });
  };

  const typeSiblingGender = [
    {
      value: "male",
      label: "Male",
    },
    {
      value: "female",
      label: "Female",
    },
  ];

  const generateNewRow = () => {
    setsiblingChild((c) => [...c, {}]);
    setChildRequired(true);
  };

  useEffect(() => {
    if (studentdata && !studentdata.lead_contact_no) {
      generateNewRow();
    }
  }, [studentdata]);

  const deleteRow = (index) => {
    const newSiblingChild = siblingChild.filter((item, i) => i !== index);
    setsiblingChild(newSiblingChild);
  };

  const ExistStudentDatails = () =>
    existChild.map((child, index) => (
      <Grid key={child.id}>
        <Typography variant="h5" className={classes.subsectionHeading}>
          Exist child Details
        </Typography>
        <Grid container spacing={3} alignItems="center">
          <Grid item md={3} sm={3} xs={12}>
            <TextField
              id="fullName"
              margin="dense"
              disabled
              label="Student Full Name"
              defaultValue={child.child_name || ""}
              required
              className={classes.textField}
            />
          </Grid>
          <Grid item md={3} sm={3} xs={6}>
            <TextField
              className={classes.textField}
              label="Gender"
              margin="dense"
              disabled
              onChange={(e) => {
                editNewChild(e, index, "child_gender");
              }}
              required
              select
              value={
                (child.child_gender && child.child_gender.toLowerCase()) || ""
              }
            >
              {typeSiblingGender &&
                typeSiblingGender.map((data) => (
                  <MenuItem
                    value={data.value}
                    key={data.value}
                    name={data.value}
                  >
                    {data.label ? data.label : ""}
                  </MenuItem>
                ))}
            </TextField>
          </Grid>
          <Grid item md={3} sm={3} xs={6}>
            <TextField
              className={classes.textField}
              label="Grade"
              margin="dense"
              disabled
              // onChange={gradeHandler}
              required
              select
              value={child.child_class && child.child_class.id}
            >
              {grade &&
                grade.map((type) => (
                  <MenuItem value={type.id} key={type.id} name={type.grade}>
                    {type.grade ? type.grade : ""}
                  </MenuItem>
                ))}
            </TextField>
          </Grid>
          <Grid item md={3} sm={3} xs={12}>
            <TextField
              className={classes.textField}
              type="date"
              label="Date Of Birth"
              margin="dense"
              disabled
              required
              variant="outlined"
              value={child.Date_of_birth || ""}
              onChange={(e) => {
                editNewChild(e, index, "child_Date_of_birth");
              }}
              InputLabelProps={{ shrink: true }}
              inputProps={{
                max: moment().format("YYYY-MM-DD"),
              }}
            />
          </Grid>
        </Grid>
      </Grid>
    ));
  const SiblingDetails = () =>
    siblingChild.map((sibChild, index) => (
      <React.Fragment key={sibChild.id || index + 1}>
        <Grid container spacing={3} alignItems="center">
          <Grid item md={3} sm={3} xs={12}>
            <TextField
              type="text"
              margin="dense"
              label="Child Full Name"
              required
              fullWidth
              value={sibChild.child_name || ""}
              className={classes.textField}
              onChange={(e) => {
                siblingNewChild(e, index, "child_name");
              }}
            />
          </Grid>
          <Grid item md={3} sm={3} xs={6}>
            <TextField
              className={classes.textField}
              label="Child Gender"
              margin="dense"
              onChange={(e) => {
                siblingNewChild(e, index, "child_gender");
              }}
              required
              select
              fullWidth
              value={
                (sibChild.child_gender &&
                  sibChild.child_gender.toLowerCase()) ||
                ""
              }
            >
              {typeSiblingGender &&
                typeSiblingGender.map((data) => (
                  <MenuItem
                    value={data.value}
                    key={data.value}
                    name={data.value}
                  >
                    {data.label ? data.label : ""}
                  </MenuItem>
                ))}
            </TextField>
          </Grid>
          <Grid item md={3} sm={3} xs={6}>
            <TextField
              className={classes.textField}
              type="date"
              margin="dense"
              label="Date of Birth"
              required
              fullWidth
              value={sibChild.Date_of_birth || ""}
              InputLabelProps={{ shrink: true }}
              inputProps={{
                max: moment().format("YYYY-MM-DD"),
              }}
              onChange={(e) => {
                siblingNewChild(e, index, "Date_of_birth");
              }}
            />
          </Grid>
          <Grid item md={2} sm={2} xs={10}>
            <TextField
              className={classes.textField}
              label="Grade"
              margin="dense"
              onChange={(e) => {
                siblingNewChild(e, index, "child_class");
              }}
              required
              fullWidth
              select
              value={(sibChild.child_class && sibChild.child_class.id) || ""}
            >
              {grade &&
                grade.map((data) => (
                  <MenuItem value={data.id} key={data.id} name={data.id}>
                    {data.grade ? data.grade : ""}
                  </MenuItem>
                ))}
            </TextField>
          </Grid>
          <Grid item md={1} sm={1} xs={2}>
            <Delete
              className={classes.deleteIcon}
              style={{ cursor: "pointer", marginTop: 15 }}
              onClick={() => deleteRow(index)}
            />
          </Grid>
        </Grid>
      </React.Fragment>
    ));

  return (
    <>
      <Grid item md={8} xs={11}>
        <Grid
          container
          // spacing={1}
          alignItems="center"
          justifyContent="center"
          className={classes.paper}
          style={{
            backgroundColor: "white",
            borderColor: "#DCDCDC",
            padding: "10px 20px",
            margin: "20px 0px",
          }}
        >
          <Grid item xs={12} md={12}>
            <Grid
              container
              alignItems="center"
              justifyContent="space-between"
              spacing={1}
            >
              <Grid item xs={12} sm={4}>
                <Grid container justifyContent="center">
                  <img
                    src={OrchidsLogo}
                    alt="image1"
                    style={{ objectFit: "cover" }}
                  />
                </Grid>
              </Grid>
              <Grid item xs={12} sm={4}>
                <Grid container direction="column" alignItems="center">
                  <Grid item>
                    <Typography variant="h3">Enquiry Form</Typography>
                  </Grid>
                  <Grid item style={{ textAlign: "center" }}>
                    <Typography variant="h5">
                      (Branch:{" "}
                      {branchList.length &&
                        branchList.filter(
                          (item) => item.id === parseInt(branchId)
                        )[0].branch_name}
                      )
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={0} sm={4}></Grid>
            </Grid>
            <Divider className={classes.divider} />
          </Grid>
          <Grid item xs={12} md={12}>
            <Grid container direction="row" spacing={3}>
              <Grid item xs={12} md={4}>
                <TextField
                  label="Academic Year"
                  margin="dense"
                  onChange={(e) => {
                    setAcademicYear(e.target.value);
                  }}
                  fullWidth
                  required
                  select
                  value={academicYear}
                >
                  {academicYearList &&
                    academicYearList.map((type) => (
                      <MenuItem
                        value={type.session_year}
                        key={type.id}
                        name={type.session_year}
                      >
                        {type.session_year ? type.session_year : ""}
                      </MenuItem>
                    ))}
                </TextField>
              </Grid>
              {formType === "Add" ? (
                <Grid item xs={12} md={4}>
                  <TextField
                    className={classes.textField}
                    label="Lead Source"
                    margin="dense"
                    fullWidth
                    onChange={(e) => setSelectedSource(e.target.value)}
                    required
                    select
                    value={selectedSource}
                  >
                    {sourceList &&
                      sourceList.length &&
                      sourceList.map((type) => (
                        <MenuItem
                          value={type.id}
                          key={type.id}
                          name={type.source_name}
                        >
                          {type.source_name}
                        </MenuItem>
                      ))}
                  </TextField>
                </Grid>
              ) : null}
            </Grid>
          </Grid>
          <Grid item xs={12} md={12}>
            <Grid container spacing={3}>
              <Grid item md={12} sm={12} xs={12}>
                {ExistStudentDatails()}
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} md={12} style={{ marginTop: 15 }}>
            <Grid container alignItems="center" justifyContent="space-between">
              <Grid item>
                <Typography variant="h5" className={classes.subsectionHeading}>
                  New child Details
                </Typography>
              </Grid>
              <Grid item>
                <Button
                  color="primary"
                  variant="contained"
                  size="small"
                  onClick={generateNewRow}
                  className={classes.addRowButton}
                >
                  Add New Child
                </Button>
              </Grid>
            </Grid>
            <Grid item xs={12} md={12}>
              {SiblingDetails()}
            </Grid>
            <Divider className={classes.divider} />
            <Typography
              variant="h5"
              className={classes.subsectionHeading}
              style={{ marginTop: 10 }}
            >
              Parent/Guardian Details
            </Typography>
            <Grid container spacing={3}>
              <Grid item md={4} sm={4} xs={12}>
                <TextField
                  type="text"
                  margin="dense"
                  label="Lead Name"
                  value={leadName}
                  required
                  fullWidth
                  onChange={leadNameHandler}
                />
              </Grid>

              <Grid item md={3} sm={3} xs={12}>
                <TextField
                  type="number"
                  margin="dense"
                  label="Mobile Number"
                  value={leadNumber}
                  disabled={leadNumber !== ""}
                  required
                  fullWidth
                  style={{ marginBottom: -10 }}
                  className={classes.numberTextField}
                />
              </Grid>
              <Grid item md={2} sm={2} xs={3}>
                <TextField
                  className={classes.textField}
                  label="&nbsp;"
                  // SelectProps={{
                  //   classes: {
                  //     select: classes.resize,
                  //   },
                  // }}
                  margin="dense"
                  size="small"
                  fullWidth
                  onChange={(e) => setCountryCode(e.target.value)}
                  onClick={refreshContact}
                  select
                  value={countryCode || ""}
                >
                  {countryCodeArray &&
                    countryCodeArray.map((data) => (
                      <MenuItem
                        value={data.value}
                        key={data.value}
                        name={data.value}
                      >
                        {data.value ? data.value : ""}
                      </MenuItem>
                    ))}
                </TextField>
              </Grid>
              <Grid item md={3} sm={3} xs={9}>
                <TextField
                  margin="dense"
                  label="Alternate Mobile"
                  value={alternateMobile || ""}
                  inputProps={{
                    maxLength: maxRange,
                  }}
                  fullWidth
                  // required
                  className={classes.textField}
                  // eslint-disable-next-line no-nested-ternary
                  helperText={
                    alternateMobile &&
                    alternateMobile.length === 10 &&
                    validNo &&
                    validNo.status !== 200 ? (
                      <span style={{ color: "red" }}>
                        {validNo && validNo.Message}
                      </span>
                    ) : alternateMobile &&
                      alternateMobile.length === 10 &&
                      validNo &&
                      validNo.status === 200 ? (
                      <span style={{ color: "green" }}>Verified</span>
                    ) : (
                      ""
                    )
                  }
                  onChange={(e) => alternateMobileHandler(e.target.value)}
                />
              </Grid>
              <Grid item md={4} sm={4} xs={12}>
                <TextField
                  type="email"
                  margin="dense"
                  label="Email Id"
                  value={email}
                  required
                  fullWidth
                  style={{ marginTop: -10 }}
                  onChange={leadEmailHandler}
                />
              </Grid>
            </Grid>
            <Divider className={classes.divider} />
            <Typography variant="h5" className={classes.subsectionHeading}>
              Address Details
            </Typography>
            <Grid container spacing={3} alignItems="center">
              <Grid item md={5} sm={5} xs={12}>
                <TextField
                  type="text"
                  margin="dense"
                  label="Address Details"
                  value={address}
                  multiline
                  required
                  className={classes.textField}
                  fullWidth
                  onChange={AddressDetailsHandler}
                />
              </Grid>
              {showModal && (
                <Grid item md={5} sm={5} xs={12}>
                  <TextField
                    type="text"
                    margin="dense"
                    label="Google Address"
                    disabled
                    value={googleAddress}
                    multiline
                    fullWidth
                    required
                    className={classes.textField}
                    InputLabelProps={{ shrink: true }}
                    // variant="outlined"
                    // onChange={AddressDetailsHandler}
                  />
                </Grid>
              )}
              <Grid item md={2} sm={2} xs={12}>
                <Button
                  className={classes.CreateEnquiry}
                  color="primary"
                  size="small"
                  variant="contained"
                  onClick={() => showMap()}
                >
                  {showModal ? "Hide Map" : "Map"}
                </Button>
              </Grid>
              {showModal && (
                <Grid
                  item
                  md={12}
                  sm={12}
                  xs={12}
                  style={{ margin: "10px", height: 410 }}
                >
                  <Map
                    google={googleAddress}
                    center={{
                      lat: +lat || +branchLoc.lat,
                      lng: +lng || +branchLoc.lng,
                    }}
                    height="400px"
                    studentdata={studentdata}
                    contactno={newContact}
                    setMapData={setMapData}
                    zoom={15}
                  />
                </Grid>
              )}
            </Grid>
            <Divider className={classes.divider} />
            <Grid
              container
              spacing={3}
              justifyContent="center"
              alignItems="center"
              style={{ margin: "10px 0px" }}
            >
              <Button
                className={classes.CreateEnquiry}
                color="primary"
                variant="contained"
                onClick={() => submitForm()}
                style={{ width: 150 }}
              >
                Submit
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      {circularProgress}
    </>
  );
};

export default withStyles(styles)(FormEnquiry);
